var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Affiche"},[_c('div',{staticClass:"Affiche__test"},[_c('img',{attrs:{"src":require('@/commons/img/affiche.png')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }